import { INPUT_ACTION_KEY } from "../constant";
export const InputAction = (payload) => (dispatch, getState) => {
  let oldevent = { ...payload };
    dispatch({ type: INPUT_ACTION_KEY, payload: oldevent });
};
